import { createSlice } from '@reduxjs/toolkit'
import type { ApiStatus } from 'src/types/miscType'

export type LogCategory = 'all' | 'exports' | 'invoices' | 'freelancerAccess'

export type ReportingLogRow = {
	id: string
	occurredAt: string
	category: Exclude<LogCategory, 'all'>
	actionLabel: string
	actorLabel: string
	projectLabel?: string | null
	freelancerLabel?: string | null
	source: 'ExportInfo' | 'AuditEvent'
	rawAction: string
}

export type ReportingLogsInput = {
	category?: LogCategory
	search?: string
	limit?: number
	nextToken?: string | null
}

export type ReportingLogsResponse = {
	items: ReportingLogRow[]
	nextToken?: string | null
}

type ReportingState = {
	logsData: ReportingLogRow[]
	fetchLogsApiStatus: ApiStatus
	error?: string | null
	nextToken?: string | null
}

const initialState: ReportingState = {
	logsData: [],
	fetchLogsApiStatus: 'idle',
	error: null,
	nextToken: null,
}

export const reportingSlice = createSlice({
	name: 'reporting',
	initialState,
	reducers: {},
})

export default reportingSlice.reducer
